import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function Tab({
    active,
    label,
    onClick
}) {
    const className = classnames([
        'tab-list-item',
        {'tab-list-active': active}
    ]);

    return (
        <li type="button" className={className} onClick={() => onClick(label)}>
            {label}
        </li>
    );
}

Tab.propTypes = {
    active: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/common/WideGig/Tabs/Tab.js